import getClassNames from 'classnames';
import keys from 'lodash/fp/keys';
import React from 'react';
import styles from './Loader.module.scss';
import colors from '../../shared/colors.json';
import { ArrayElementType } from '../../types/utils/ArrayElementType';
import Element, { CommonProps } from '../Element/Element';

export const supportedLoaderSizes = ['sm', 'md', 'lg'] as const;
export type SupportedLoaderSizes = ArrayElementType<
  typeof supportedLoaderSizes
>;

type LoaderProps = {
  /** Size of the icon */
  size?: SupportedLoaderSizes;
  /** Changes loader to be white. Recommended to be used on dark backgrounds */
  light?: boolean;
} & CommonProps<'span'>;

const Loader: React.FunctionComponent<LoaderProps> = ({
  className,
  size = 'lg',
  light,
  ...props
}) => {
  const cssClassBySize: { [key: string]: string } = {
    sm: 'loaderSmall',
    md: 'loaderMedium',
    lg: 'loaderLarge',
  };
  const loaderSize = cssClassBySize[size];
  const classNames = getClassNames(styles[loaderSize], className);

  return (
    <Element tagName="span" className={classNames} {...props}>
      {[...keys(new Array(8))].map((key) => (
        <span key={key} className={styles[`${loaderSize}__iconContainer`]}>
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path
              fill={!!light ? colors.white.color : colors.purple500.color}
              d="M22.9349564,6.18803226 C22.9349564,2.1584087 19.969785,0.763523756 16.6924777,0.763523756 C9.82572717,0.763523756 1.39837693,5.25812218 1.39837693,10.9925743 C1.39837693,15.4871727 7.4848276,23.2364762 12.0105987,23.2364762 C16.3803418,23.2364762 22.9349564,16.1071392 22.9349564,6.18803226 Z"
            />
          </svg>
        </span>
      ))}
    </Element>
  );
};

export default Loader;
